import { axiosInstance } from "src/boot/AxiosInstances"
import { ContactAndVolunteerDetailsUpdateFlow, mergeManyFamilySeasonCompVolReqChecks } from "src/composables/registration"
import { FamilySeasonCompetitionVolunteerRequirementsCheck, Guid } from "src/interfaces/InleagueApiV1"

import * as R_ContactAndVolunteerDetailsUpdateFlow from "src/components/Registration/selections/R_ContactAndVolunteerDetailsUpdateFlow.route"
import * as R_RegistrationRelationshipCheck from 'src/components/Registration/playerUserRelations/R_RegistrationRelationshipCheck.route'
import * as R_SelectCompetitions from "src/components/Registration/selections/R_SelectCompetitions.route"

import { RouteLocationRaw } from "vue-router"
import { checkFamilySeasonCompetitionVolunteerRequirements } from "src/composables/InleagueApiV1"

export {
  afterSelectPlayerRoute,
  afterSelectCompetitionsRoute,
  afterContactAndVolunteerDetailsUpdateFlowRoute,
  afterVolReqRoute,
}

async function afterSelectPlayerRoute(args: {seasonUID: Guid, playerID: Guid}) : Promise<RouteLocationRaw> {
  return R_SelectCompetitions.routeDetailToRouteLocation(
      R_SelectCompetitions.RouteNames.selectCompetitions, {
        playerID: args.playerID,
        seasonUID: args.seasonUID
      }
  )
}

async function afterSelectCompetitionsRoute(args: {userID: Guid, childID: Guid, familyID: Guid, seasonUID: Guid, competitionUIDs: Guid[]}) : Promise<RouteLocationRaw> {
  {
    const usersNeedingUpdate = await ContactAndVolunteerDetailsUpdateFlow.checkRequirement(
      axiosInstance,
      args.familyID,
      args.seasonUID
    )

    if (usersNeedingUpdate.length > 0) {
      await ContactAndVolunteerDetailsUpdateFlow.setFlowState_fromPreCheck(
        axiosInstance,
        args.childID,
        args.familyID,
        args.seasonUID,
        usersNeedingUpdate
      )

      return R_ContactAndVolunteerDetailsUpdateFlow.routeDetailToRouteLocation({
          childID: args.childID,
          seasonUID: args.seasonUID,
          userListIndex: 0,
          step: 1,
          competitionUIDs: args.competitionUIDs
      })
    }
  }

  return volReqOrRelCheckRoute(args)
}

async function afterContactAndVolunteerDetailsUpdateFlowRoute(args: {userID: Guid, familyID: Guid, seasonUID: Guid, childID: Guid, competitionUIDs: Guid[]}) : Promise<RouteLocationRaw> {
  return await volReqOrRelCheckRoute(args)
}

async function afterVolReqRoute(args: {childID: Guid, seasonUID: Guid, competitionUIDs: Guid[]}) : Promise<RouteLocationRaw> {
  return userPlayerRelationshipCheck(args)
}

async function volReqOrRelCheckRoute(args: {userID: Guid, familyID: Guid, seasonUID: Guid, childID: Guid, competitionUIDs: Guid[]}) {
  const volReqRoute = await volReqsRouteIfNecessary(args)

  if (volReqRoute) {
    return volReqRoute
  }
  else {
    return userPlayerRelationshipCheck(args)
  }
}

async function volReqsRouteIfNecessary(args: {userID: Guid, familyID: Guid, seasonUID: Guid, childID: Guid, competitionUIDs: Guid[]}) : Promise<RouteLocationRaw | null> {
  const volunteerRequirementsCheck : FamilySeasonCompetitionVolunteerRequirementsCheck[] = []
  for (const competitionUID of args.competitionUIDs) {
    volunteerRequirementsCheck.push(
      await checkFamilySeasonCompetitionVolunteerRequirements(
        axiosInstance,
        args.familyID,
        args.seasonUID,
        competitionUID
      )
    )
  }

  const mergedVolReqChecks = mergeManyFamilySeasonCompVolReqChecks(volunteerRequirementsCheck);

  if (!mergedVolReqChecks.satisfiesVolunteerRequirement) {
    return R_SelectCompetitions.routeDetailToRouteLocation(R_SelectCompetitions.RouteNames.postSelectCompUpdateVolInfo, {
      seasonUID: args.seasonUID,
      playerID: args.childID,
      familyID: args.familyID,
      userID: args.userID,
      competitionUIDs: args.competitionUIDs
    })
  }
  else {
    return null
  }
}

function userPlayerRelationshipCheck(args: {childID: Guid, seasonUID: Guid, competitionUIDs: Guid[]}) {
  return R_RegistrationRelationshipCheck.routeDetailToRouteLocation({
    seasonUID: args.seasonUID,
    competitionUIDs: args.competitionUIDs,
    playerID: args.childID,
  })
}
